import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheckCircle, 
  faExclamationCircle, 
  faExclamationTriangle, 
  faInfoCircle 
} from '@fortawesome/free-solid-svg-icons';

const AlertModal = ({ 
  show, 
  onHide, 
  title, 
  message, 
  variant = "info", 
  buttonText = "OK",
  buttonVariant = "primary"
}) => {
  const getVariantConfig = () => {
    switch (variant) {
      case "success":
        return {
          icon: faCheckCircle,
          bg: "bg-success-light",
          text: "text-success",
          border: "border-success"
        };
      case "error":
      case "danger":
        return {
          icon: faExclamationCircle,
          bg: "bg-danger-light",
          text: "text-danger",
          border: "border-danger"
        };
      case "warning":
        return {
          icon: faExclamationTriangle,
          bg: "bg-warning-light",
          text: "text-warning",
          border: "border-warning"
        };
      default:
        return {
          icon: faInfoCircle,
          bg: "bg-info-light",
          text: "text-info",
          border: "border-info"
        };
    }
  };

  const { icon, bg, text, border } = getVariantConfig();

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      backdrop="static"
      className="fade-in"
    >
      <Modal.Header 
        closeButton 
        closeVariant={variant === 'warning' || variant === 'error' ? 'white' : undefined}
        className={`${bg} ${text} ${border} border-bottom-0 rounded-top`}
      >
        <Modal.Title className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={icon} className="me-2" />
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <div className="d-flex align-items-start gap-3">
          <FontAwesomeIcon 
            icon={icon} 
            className={`${text} mt-1`} 
            size="lg"
          />
          <div className="flex-grow-1">
            {typeof message === 'string' ? (
              <p className="mb-0">{message}</p>
            ) : (
              message
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button 
          variant={buttonVariant} 
          onClick={onHide}
          className="px-4"
        >
          {buttonText}
        </Button>
      </Modal.Footer>
      <style>{`
  .bg-success-light {
    background-color: rgba(40, 167, 69, 0.1) !important;
  }
  .bg-danger-light {
    background-color: rgba(220, 53, 69, 0.1) !important;
  }
  .bg-warning-light {
    background-color: rgba(255, 193, 7, 0.1) !important;
  }
  .bg-info-light {
    background-color: rgba(23, 162, 184, 0.1) !important;
  }
  .fade-in {
    animation: fadeIn 0.2s ease-in-out;
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`}</style>

    </Modal>
  );
};

export default AlertModal;
